import ResponsiveRender from "./ResponsiveRender";
export default ResponsiveRender;
